<script lang="ts">
	
	import {storeDomain, storeIsOpenBurger, storeIsFirstDisplay} from '../scripts/store'
    import { redirectTo } from "../scripts/router1";
    import {
        idPageAmenagements,
        idPageServices,
    } from "../scripts/router2";

	function toogleDomain() {
		let newDomain = "";
		if ($storeDomain == "services") {
			newDomain = "amenagements";
			redirectTo(idPageAmenagements);
		} else if ($storeDomain == "amenagements") {
			newDomain = "services";
			redirectTo(idPageServices);
		}
		storeDomain.set(newDomain);
		storeIsFirstDisplay.set(false);
	}

</script>

<div class="footer" class:footer--open={$storeIsOpenBurger && $storeDomain == "amenagements"} class:footer--opendesk={$storeDomain == "amenagements"}>
	<div class="footer__triangle footer__triangle__services"></div>
	<div class="footer__logo footer__logo__services">
		<img class="footer__logo__img" src="../images/logo-services.png" alt="logo" on:click={() => toogleDomain()} on:keydown={() => toogleDomain()}>
	</div>
	<div class="footer__burger footer__burger__services">
		<img class="footer__burger__img" src="../images/burger-services-arrow.png" alt="burger" on:click={() => toogleDomain()} on:keydown={() => toogleDomain()}>
	</div>
</div>
<div class="footer" class:footer--open={$storeIsOpenBurger && $storeDomain == "services"} class:footer--opendesk={$storeDomain == "services"}>
	<div class="footer__triangle footer__triangle__amenagements"></div>
	<div class="footer__logo footer__logo__amenagements">
		<img class="footer__logo__img" src="../images/logo-amenagements.png" alt="logo" on:click={() => toogleDomain()} on:keydown={() => toogleDomain()}>
	</div>
	<div class="footer__burger footer__burger__amenagements">
		<img class="footer__burger__img" src="../images/burger-amenagements-arrow.png" alt="burger" on:click={() => toogleDomain()} on:keydown={() => toogleDomain()}>
	</div>
</div>


<style lang="scss">

	.footer {
        display: grid;
        grid-template-areas: "logo triangle burger";
        grid-template-columns: 80% 1fr 12%;
		width: 100%;
		height: $header-height;
		position: fixed;
		bottom: 0px;
		right: 0px;
		z-index: 100000;
		transition: transform;
		transition-duration: 1.5s;
		transform: translateY(calc(100% + 60px));
		&--open {
			transform: translateY(0);
		}
		&__logo {
			grid-area: logo;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: flex-start;
			padding: 0 0 0 $contener-marge-small;
			&__services {
				background-color: $color-bleu-instit;
			}
			&__amenagements {
				background-color: $color-bordeau-instit;
			}
			&__img {
				width: auto;
				height: 30px;
			}
		}
		&__triangle {
			grid-area: triangle;
			width: 100%;
			height: 100%;
			&__services {
				background-color: $color-bleu-instit;
			}
			&__amenagements {
				background-color: $color-bordeau-instit;
			}
		}
		&__burger {
			grid-area: burger;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: flex-end;
			padding: 0 $contener-marge-small 0 0;
			&__services {
				background-color: $color-bleu-instit;
			}
			&__amenagements {
				background-color: $color-bordeau-instit;
			}
			&__img {
				width: auto;
				height: 35px;
			}
		}
	}

	@include large {
		.footer {
            z-index: 100;
            display: grid;
			grid-template-areas: "vide triangle logo";
			grid-template-columns: 1fr 10% 33%;
            justify-content: flex-end;
            align-items: inherit;
            position: fixed;
            bottom: 0;
            right: 0;
            padding: 0 0 15px 0;
            width: 100%;
            max-width: 100%;
            border-radius: 0px;
			background-color: inherit;
			transition-delay: 1s;
			transition-duration: 1s;
			&--open {
				transform: translateY(calc(100% + 60px));
			}
			&--opendesk {
				transform: translateY(0);
			}
			&__triangle {
				grid-area: triangle;
				clip-path: polygon(98% 0%, 100% 100%, 50% 100%);
				margin: 0 -2px 0 0;
				width: 75px;
				height: 80px;
				justify-self: flex-end;
				&__services {
					background-color: $color-bleu-instit;
				}
				&__amenagements {
					background-color: $color-bordeau-instit;
				}
			}
			&__logo {
				grid-area: logo;
				cursor: pointer;
				padding: 15px 15px 15px 15px;
				&__services {
					background-color: $color-bleu-instit;
				}
				&__amenagements {
					background-color: $color-bordeau-instit;
				}
				&__img {
					width: auto;
					height: 40px;
					padding: 0;
				}
			}
			&__burger {
				display: none;
			}				
		}
	}
</style>